import React, { useState } from "react";
import { Icon, Segment, Form, Header, Button, Input } from "semantic-ui-react";
import { Link } from "react-router-dom";
import Modal from "react-responsive-modal";
import { connect } from "react-redux";

import { createInboundShipment } from "../../../actions/inboundparcel";
import WarehouseFilter from "../../Filters/WarehouseFilter";
import BusinessclientFilter from "../../Filters/BusinessclientFilter";
import CanViewPage from "../../../role-based-access/CanViewPage";

const itemStyle = {
  margin: "2px",
  minWidth: "345px",
  maxWidth: "360px",
  border: "none !important",
  color: "#3F72AF !important",
};

function Createinboudparcel(props) {
  const { createInboundShipment, history } = props;
  const [shipment, setFields] = useState({
    warehouse: "",
    businessclient: "",
    seller: "",
    transporter: "",
    nrOfPacks: "",
    weightKg: "",
  });
  const [isCompanyModalOpen, setCompanyModal] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const handleInputChange = (e, { name, value }) => {
    setFields({ ...shipment, [name]: value });
  };
  const toggleCompanyModal = () => {
    setCompanyModal(!isCompanyModalOpen);
  };
  const handleCreateShipment = () => {
    setLoading(true);
    createInboundShipment({ shipment, history });
  };

  return (
    <CanViewPage path="/shipments/inbound/new">
      <main className="page-wrapper a-wrapper">
        <Link to="/parcels/inbound/">
          <Icon name="arrow left" /> Inbound Parcels List
        </Link>
        <Segment padded loading={isLoading}>
          <div className="flex--between">
            <Header as="h3">New Inbound Parcel/Letter</Header>
          </div>

          <div className="new-inbound-shipment__grid">
            <div className="new-inbound-shipment__col">
              <Form.Field className="new-inbound-shipment__field">
                <label>Warehouse</label>
                <WarehouseFilter
                  style={itemStyle}
                  useFilter={false}
                  multiple={false}
                  value={shipment.warehouse}
                  handleChange={(value) =>
                    handleInputChange(null, { name: "warehouse", value })
                  }
                  name="warehouse"
                />
              </Form.Field>
              <Form.Field className="new-inbound-shipment__field">
                <label>Business Client</label>
                <BusinessclientFilter
                  style={itemStyle}
                  useFilter={false}
                  name="businessclient"
                  value={shipment.businessclient}
                  handleChange={(value) =>
                    handleInputChange(null, { name: "businessclient", value })
                  }
                />
              </Form.Field>
              {/* <Form.Field className="new-inbound-shipment__field">
                <label className="flex--left vertical--bottom">
                  Supplier:
                  {shipment.client && (
                    <Button
                      style={{ marginLeft: "1.4em", marginTop: "-5px" }}
                      //   circular
                      //   basic
                      compact
                      icon="plus"
                      size="mini"
                      className="parties__addbtn"
                      onClick={toggleCompanyModal}
                    />
                  )}
                </label>
                <SellerFilter
                  value={shipment.seller}
                  client={shipment.client}
                  handleChange={handleInputChange}
                />
              </Form.Field> */}
            </div>
            <div className="new-inbound-shipment__col">
              <Form.Field
                className="new-inbound-shipment__field"
                control={Input}
                label="Transport Company:"
                placeholder="company name..."
                name="transporter"
                value={shipment.transporter}
                onChange={handleInputChange}
              />
              {/* <Form.Field
                className="new-inbound-shipment__field"
                control={Input}
                label="Nr. of packs:"
                placeholder="packs..."
                name="nrOfPacks"
                value={shipment.nrOfPacks}
                onChange={handleInputChange}
              /> */}
              <Form.Field
                className="new-inbound-shipment__field"
                control={Input}
                label="Weight (kg):"
                placeholder="kg..."
                name="weigthKg"
                value={shipment.weigthKg}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <Modal
            open={isCompanyModalOpen}
            showCloseIcon={true}
            closeOnEsc={true}
            onClose={toggleCompanyModal}
            center
            classNames={{
              modal: "",
            }}
          >
            {/* <Companyform
              company={shipment.client} //businessclient
              createCo={createCo}
              closeForm={toggleCompanyModal}
            /> */}
          </Modal>
          <Button fluid={true} color="blue" onClick={handleCreateShipment}>
            Create Parcel
          </Button>
        </Segment>
      </main>
    </CanViewPage>
  );
}

// const mapStateToProps = reduxState => ({});

export default connect(null, { createInboundShipment })(Createinboudparcel);
